import * as ngCore from '@angular/core'

import * as state from '../../../../../../../../state'
import * as section from '../../section'

/**
 * TODO:
 */
@ngCore.Component({
  imports: [section.Component],
  selector: 'atn-summit-pulse-team-spirit',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** {@link state.summit.pulse.Feature} */
  public readonly pulseFeature = ngCore.inject(state.summit.pulse.Feature)
}
